export const serviceStore = {};
export const resetServiceStore = () => Object.keys(serviceStore).forEach((key) => delete serviceStore[key]);
//# sourceMappingURL=stores.js.map